var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.369,
    height: 71.051,
    viewBox: "0 0 88.369 71.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_payment-cash",
    "data-name": "Icon payment-cash",
    d: "M82.522,18.875V64.637a3.26,3.26,0,0,1-.743,1.783A2.428,2.428,0,0,1,80,67.164H8.975a2.42,2.42,0,0,1-1.782-.743,3.248,3.248,0,0,1-.743-1.783V18.875a3.256,3.256,0,0,1,.743-1.783,2.432,2.432,0,0,1,1.783-.743H80a2.437,2.437,0,0,1,1.783.743,3.272,3.272,0,0,1,.744,1.783ZM77.47,51.861V31.653a9.719,9.719,0,0,1-7.132-2.972A9.892,9.892,0,0,1,67.366,21.4H21.6a9.9,9.9,0,0,1-2.972,7.281A9.725,9.725,0,0,1,11.5,31.653V51.86a9.735,9.735,0,0,1,7.132,2.972A9.906,9.906,0,0,1,21.6,62.112H67.366a9.9,9.9,0,0,1,2.972-7.281,9.732,9.732,0,0,1,7.132-2.971Zm-20.355-10.1a26.037,26.037,0,0,1-.743,5.646,19.04,19.04,0,0,1-2.377,5.349,12.913,12.913,0,0,1-4.011,4.011,10.911,10.911,0,0,1-10.994,0,12.87,12.87,0,0,1-4.011-4.011A18.991,18.991,0,0,1,32.6,47.4a25.915,25.915,0,0,1-.743-5.646A25.938,25.938,0,0,1,32.6,36.11a18.982,18.982,0,0,1,2.377-5.349,12.912,12.912,0,0,1,4.011-4.011,10.91,10.91,0,0,1,10.993,0,12.978,12.978,0,0,1,4.011,4.011,19.047,19.047,0,0,1,2.377,5.349,26.013,26.013,0,0,1,.744,5.646Zm-20.207,10.1H52.063V48.146H47.011V30.317H42.554l-5.943,5.5,3.12,3.12a24.325,24.325,0,0,0,2.08-2.229h.148v11.44H36.907v3.716Z",
    transform: "translate(-10.088 7.648) rotate(-16)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.2d0ccc75d247653c89c75431ca286593.svg";
export { ForwardRef as ReactComponent };